

export const SCORE_SHORTAGE_MULTIPLIER = 10
